import ServerEnv from '@leuven2030/framework/Server/ServerEnv';

const ServerPort = process.env.PORT;

if (!ServerPort && ServerEnv.isDev) {
  console.warn('Could not find port');
}

export default ServerPort;
